<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="svg-icon">
    <path
      d="M16.37,6.57,10,12.76,3.63,6.57"
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="2"
      transform="rotate(90, 10, 10)"
    />
  </svg>
</template>
